import { qrcode, mask, Toast } from './componentsUI'

export * from './components'
export * from './componentsUI'

export default {
  install(Vue, opt) {
    Vue.use(Toast)

    // 注册全局组件
    Vue.component('cg_mask', mask)
    Vue.component('qrcode', qrcode)
  },
}
